import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import uuid from 'uuid/v4';

const NavbarHU = ({ active }) => {
  const menuItems = [
    { name: 'Home', url: '/' },
    { name: 'Rólunk', url: '/rolunk' },
    { name: 'Galéria', url: '/galeria' },
    { name: 'Kapcsolat', url: '/kapcsolat' }
  ];

  const [mainMenu, setMainMenu] = useState(false);

  const onClick = e => {
    setMainMenu(!mainMenu);
  };

  return (
    <header className='header'>
      <div className='logo'>
        <span className='k-orange regular'>Kárai</span> Galéria
      </div>
      <nav className={mainMenu ? 'header-nav open' : 'header-nav'}>
        <ul className='lang'>
          <li>
            <Link to='/' className='active'>
              hu
            </Link>
          </li>
          <li>
            <Link to='/home'>en</Link>
          </li>
        </ul>
        <ul className='main-menu'>
          {menuItems.map(mitem => (
            <li key={uuid()}>
              <Link
                to={mitem.url}
                className={active === mitem.name ? 'active' : ''}
              >
                {mitem.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className='hamburger-menu' onClick={e => onClick(e)}></div>
    </header>
  );
};

export default NavbarHU;
